export default "<app-admin-header></app-admin-header>\n<ng-content select=\"router-outlet\"></ng-content>\n"